import React, { useEffect, useRef } from 'react';
import { useTheme } from 'styled-components';
import { useIntl } from 'react-intl';

import { useLaunchDarkly } from '../../store/LaunchDarkly';
import { useUserAccount } from '../../store/UserAccount';

import { ModuleContainer } from './styles';

interface IProps {
  src: string;
  id: string;
}

const ModuleLoader = ({ src, id }: IProps) => {
  const { activeAccountId } = useUserAccount(); // TODO: remove and use event sub?
  const scriptRef = useRef<HTMLScriptElement | null>(null);
  const { name: brand } = useTheme();
  const { locale } = useIntl();
  const launchDarkly = useLaunchDarkly();
  const env = launchDarkly['config-web-app']?.env;
  const graphqlConfig = launchDarkly['config-web-app']?.ecosystem?.graphql;

  useEffect(() => {
    window.SHARED_MODULE_DATA.brand = brand;
    window.SHARED_MODULE_DATA.locale = locale;
    window.SHARED_MODULE_DATA.env = env;
    window.SHARED_MODULE_DATA.accountId = activeAccountId;
    window.SHARED_MODULE_DATA.graphql = graphqlConfig;

    const script = document.createElement('script');
    script.setAttribute('module-id', id);
    script.src = src;
    script.async = true;

    script.onload = () => {
      globalThis.dispatchEvent(new PopStateEvent('popstate', { state: globalThis.history.state }));
    };

    document.body.appendChild(script);
    scriptRef.current = script;

    return () => {
      if (scriptRef.current) {
        scriptRef.current.remove();
        // TODO: may needs to be improved so we can remove by id
      }
    };
  }, [src, id, locale, brand, env, activeAccountId, graphqlConfig]);

  return <ModuleContainer id={id} />;
};

export default ModuleLoader;
